import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ProductDetailsModule from "./Module";
import { DatoCmsProductVariantFragment_modules_DatoCmsCModulePvTechSpec } from "../../../../../fragments/__generated__/DatoCmsProductVariantFragment";
import { Box, Typography } from "@material-ui/core";
import { formatMultilinesText } from "../../../../../helpers/markdown";

const useStyles = makeStyles(theme => ({
  list: {
    listStyleType: `none`,
    padding: 0,
    margin: 0
  },
  listItem: {
    width: `100%`,
    display: `flex`,
    flexDirection: `row`,
    justifyContent: `space-between`,
    "&:not(:first-child)": {
      paddingTop: theme.spacing(1)
    },
    "&:not(:last-child)": {
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.grey[400]}`
    },
    "& > span": {
      flex: `1 1 0`
    },
    [theme.breakpoints.down(`sm`)]: {
      // Larger value column on mobile
      "& > span": {
        flex: `2 1 0`
      },
      "& > span:last-child": {
        flex: `3 1 0`
      }
    }
  },
  specTitle: {
    color: theme.palette.grey[600]
  }
}));

type Props = {
  data: DatoCmsProductVariantFragment_modules_DatoCmsCModulePvTechSpec & {
    description?: string;
  };
};

const ProductDetailsModuleTechSpec = ({ data }: Props) => {
  const classes = useStyles();

  return (
    <ProductDetailsModule title={data.title}>
      {data.description && (
        <Box mb={3}>
          <Typography
            dangerouslySetInnerHTML={{
              __html: formatMultilinesText(data.description)
            }}
          />
        </Box>
      )}

      {data.specs && data.specs.length > 0 && (
        <ul className={classes.list}>
          {data.specs.map(spec => (
            <li key={spec.value} className={classes.listItem}>
              <span className={classes.specTitle}>{spec.title}</span>
              <span>{spec.value}</span>
            </li>
          ))}
        </ul>
      )}
    </ProductDetailsModule>
  );
};

export default ProductDetailsModuleTechSpec;
